import {defineStore} from 'pinia';
import {ModuleGeneralVoucher} from '../moduleConst';
import {BaseVoucherStore} from '../baseVoucherStore';
import suGeneralVoucherApi from '@/apis/su/suGeneralVoucherAPI.js';
// const
import {MSConstant} from '@/commons/wildcards';

const suGeneralVoucherStore = new BaseVoucherStore(suGeneralVoucherApi);

export const useSUAccountTransferStore = defineStore(ModuleGeneralVoucher, {
  state: () => ({
    ...suGeneralVoucherStore.state,
    _config: {
      key: MSConstant.ColumnCommon.refId,
      code: MSConstant.ColumnCommon.refNo,
      table: 'gl_voucher',
      posted: MSConstant.ColumnCommon.isPosted,
      //#region Cấu hình mặc định phục vụ lấy data list cho detail (nvthinh 1.4.2024)
      defaultSort: [MSConstant.ColumnCommon.refDate, MSConstant.ColumnCommon.refNo],
      defaultFilter: [
        {
          Field: MSConstant.ColumnCommon.refType,
          Operator: MSConstant.FilterOperator.In,
          Value: [
            MSConstant.RefType.SUAccountTransfer,
            MSConstant.RefType.TranferReceiptClear,
            MSConstant.RefType.TranferClosing,
            MSConstant.RefType.TransferBudgetBalance,
            MSConstant.RefType.TransferActivity,
            MSConstant.RefType.TransferBegining,
            MSConstant.RefType.TranferReceiptClearInMonth13,
          ],
        },
      ],
      //#endregion
    },
    moduleName: 'glAccountTransfer',
    screenCode: MSConstant.ScreenCode.SUAccountTransfer, // Cấu hình này phục vụ lấy lịch sử filter của màn danh sách (nvthinh 29.3.2024)
  }),
  actions: {
    ...suGeneralVoucherStore.action,
    /**
     * Lấy ra danh sách Kết chuyển/ Quyết toán trong năm hạch toán
     * ntban - 17.7.2023
     * @returns
     */
    async getTransferVoucher(refType, postedYear) {
      let res = null;
      try {
        res = await suGeneralVoucherApi.getTransferVoucher(refType, postedYear);
      } catch (err) {}
      return res;
    },

    /**
     * Lấy ra danh sách Kết chuyển/ Quyết toán trong năm hạch toán
     * ntban - 17.7.2023
     * @returns
     */
    async getCurrentTransferVoucherList(refType, postedYear) {
      let res = null;
      try {
        res = await suGeneralVoucherApi.getCurrentTransferVoucherList(refType, postedYear);
      } catch (err) {
        console.log(err);
      }
      return res;
    },

    /**
     * Sinh Kết chuyển/ Quyết toán
     * ntban - 17.7.2023
     * @param {} payload
     * @returns
     */
    async quickAddTransferVoucher(refType, postedDate) {
      let res = null;
      try {
        res = await suGeneralVoucherApi.quickAddTransferVoucher(refType, postedDate);
      } catch (err) {}
      return res;
    },

    /**
     * Thực hiện kết chuyển nhanh
     * @param {} payload
     * @returns
     */
    async makeQuickTransfers(payload) {
      try {
        const res = await suGeneralVoucherApi.makeQuickTransfers(payload);
        return res;
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Lấy dữ liệu từ cache (Phòng trường hợp websocket chết)
     * @param {String} traceId ID tiến trình worker
     * @author nvthinh 29.1.2024
     */
    async checkQuickTransfer(traceId) {
      try {
        const res = await suGeneralVoucherApi.checkQuickTransfer(traceId);
        return res;
      } catch (err) {
        console.log(err);
      }
    },
  },
  getters: {
    ...suGeneralVoucherStore.getters,
  },
});
